/**
 * Origine utilisée pour tous les liens publics partagés (vidéos, collections,
 * clipboard, navigator.share, réseaux sociaux, SMS).
 *
 * Le Worker Open Graph de TAMA (tama-og-proxy) ne génère titre + miniature que
 * pour le domaine de production. Les liens publics doivent donc TOUJOURS pointer
 * vers https://tama-nesian.life, quelle que soit l'origine sur laquelle l'app
 * est actuellement consultée (preview Lovable, localhost, etc.).
 *
 * Les flux OAuth / e-mail continuent d'utiliser window.location.origin, car ils
 * doivent rediriger vers l'origine courante.
 */
export const PRODUCTION_SHARE_ORIGIN = "https://tama-nesian.life";

export const getShareOrigin = (): string => PRODUCTION_SHARE_ORIGIN;
